function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#A43741;}\n\t.st2{clip-path:url(#SVGID_2_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("symbol", {
  id: "glyph0-0",
  viewBox: "-50.6 -63.7 101.2 127.4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M-27.6-44.3H40c7.2,0,10.6-4.8,10.6-9.6c0-5-3.4-9.8-10.6-9.8h-77.6c-7,0-13,5.4-13,11.8v105 c0,6.8,5.8,10.6,11.6,10.6c5.6,0,11.4-3.8,11.4-10.8V14.7h64c7,0,10.4-4.6,10.4-9.4s-3.4-9.8-10.4-9.8h-64V-44.3z"
}));

var _ref4 = /*#__PURE__*/React.createElement("symbol", {
  id: "glyph0-1",
  viewBox: "-11.7 -63.7 23.4 127.4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M-11.7-52.9V53.5c0,7,5.6,10.2,11.6,10.2c5.8,0,11.8-3.4,11.8-10.2V-52.9c0-7.4-6-10.8-11.8-10.8 C-6.1-63.7-11.7-60.3-11.7-52.9z"
}));

var _ref5 = /*#__PURE__*/React.createElement("symbol", {
  id: "glyph0-2",
  viewBox: "-60.2 -63.7 120.4 127.4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M48.4-63.7H-49c-7.8,0-11.2,5.2-11.2,10.4c0,5,3.4,10.2,11.2,10.2h37v96.2c0,7.2,6,10.6,11.6,10.6 c5.2,0,11.8-3.4,11.8-10.6l-0.2-96.2h37.2c7.6,0,11.8-5.2,11.8-10.2C60.2-58.5,56-63.7,48.4-63.7z"
}));

var _ref6 = /*#__PURE__*/React.createElement("symbol", {
  id: "glyph0-3",
  viewBox: "-50.5 -63.7 101 127.4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M-38.5,63.7h77c7.8,0,12-4.8,12-10c0-4.8-4.2-10-12-10h-65.6v-97.2c0-6.8-6-10.2-11.6-10.2 c-6,0-11.8,3.4-11.8,10.2V52.9C-50.5,59.9-47.1,63.7-38.5,63.7z"
}));

var _ref7 = /*#__PURE__*/React.createElement("symbol", {
  id: "glyph0-4",
  viewBox: "-58.4 -63.7 116.7 127.4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M-36.6-58.1c-2.6-3.6-6.2-5.6-10.6-5.6c-8.2,0-15,8.8-8.8,17l44.8,59.2v39.2c0,7.4,5.2,12,11.6,12 c5.2,0,11.6-4.6,11.6-12V12.5l43.8-58.6c6.4-8.6-0.4-17.6-8-17.6c-4.4,0-8,2.4-10.8,6.2L0.2-7.9L-36.6-58.1z"
}));

var _ref8 = /*#__PURE__*/React.createElement("symbol", {
  id: "glyph1-0",
  viewBox: "-48.8 -64.7 97.6 129.4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M-11,45.1l36.8-28.6c13.4-10.6,22-25,19.8-44.2c-2.4-23.4-23.4-37-46.2-37c-24,0-43.2,11-46.4,35.8 c-0.8,7.6,5.4,12,11.4,12c5.2,0,10.2-3,11-9.2c2.4-11.6,12-18.6,24-18.6s22.2,6.4,23.8,19.8c1.6,10-3.2,20.2-11.6,26.2l-55.8,43.8 c-3,2.4-4.6,5.6-4.6,8.4c0,5.6,4.6,10.6,11.6,11.2H37c8,0,11.8-5,11.8-10s-4.2-10.2-12-10.2H3L-11,45.1z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M982.3,224.1h-942C18.1,224.1,0,206,0,183.8V40.3C0,18.1,18.1,0,40.3,0h942c22.2,0,40.3,18.1,40.3,40.3v143.5 C1022.6,206,1004.5,224.1,982.3,224.1z"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: 25.8,
  y: 23.9,
  width: 127.9,
  height: 177
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  className: "st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M38,125.9l49.6,73.7c1,1.5,3.3,1.5,4.3,0l49.6-73.7c1.5-2.2,2.6-3.8,2.6-3.8l0,0c6.4-10.4,10-22.7,9.5-35.9 c-1.1-33-27.5-60-60.4-61.7c-36.8-1.9-67.3,27.4-67.3,63.9c0,12.4,3.5,23.9,9.6,33.7C35.4,122.1,36.6,123.9,38,125.9z M89.7,43.2 c24.9,0,45.1,20.2,45.1,45.2c0,25-20.2,45.2-45.1,45.2c-24.9,0-45.1-20.2-45.1-45.2C44.6,63.4,64.8,43.2,89.7,43.2z"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M61,73.3c0.2,0.4,0.6,0.8,1,1l15.1,10.9l4.3,25.8c0.2,1,0.7,2,1.5,2.6l2.7,2.3c0.7,0.6,1.9,0.1,1.9-0.8 l0.2-22.3l15.1,10.9c3.4,2.5,8.1,2.6,11.6,0.3l5.8-3.8c0.7-0.4,0.8-1.4,0.3-1.9l-0.6-0.7c-1.2-1.3-3-1.9-4.7-1.6l-6.6,1.3 L77.7,71.1c-3-2.6-6.8-4.1-10.7-4c-1.3,0-2.6,0.2-3.9,0.6C60.7,68.4,59.7,71.1,61,73.3C61,73.2,61,73.2,61,73.3z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M96.8,81.2c0.9,0.8,2.1,1.3,3.4,1.2l16.1-0.8c0.8-0.2,1-1.2,0.4-1.7l-2.4-1.8c-0.7-0.5-1.5-0.8-2.4-0.7 l-19.5-2.1c-0.8-0.1-1.2,0.9-0.6,1.4L96.8,81.2z"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_3_",
  x: 619.1,
  y: 181.2,
  width: 1125,
  height: 1125
}));

var SvgFit2Fly = function SvgFit2Fly(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1022.6 224.1",
    style: {
      enableBackground: "new 0 0 1022.6 224.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _ref9, /*#__PURE__*/React.createElement("g", null, _ref10, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref11), _ref12, _ref13, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-0",
    width: 101.2,
    height: 127.4,
    x: -50.6,
    y: -63.7,
    transform: "matrix(1 0 0 1 234.5447 117.5112)",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    width: 23.4,
    height: 127.4,
    x: -11.7,
    y: -63.7,
    transform: "matrix(1 0 0 1 328.4413 117.5112)",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    width: 120.4,
    height: 127.4,
    x: -60.2,
    y: -63.7,
    transform: "matrix(1 0 0 1 418.9402 117.5112)",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-0",
    width: 97.6,
    height: 129.4,
    x: -48.8,
    y: -64.7,
    transform: "matrix(1 0 0 1 547.3366 116.5112)",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref14, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_4_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-0",
    width: 101.2,
    height: 127.4,
    x: -50.6,
    y: -63.7,
    transform: "matrix(1 0 0 1 681.334 117.5112)",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    width: 101,
    height: 127.4,
    x: -50.5,
    y: -63.7,
    transform: "matrix(1 0 0 1 816.4299 117.5112)",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    width: 116.7,
    height: 127.4,
    x: -58.4,
    y: -63.7,
    transform: "matrix(1 0 0 1 935.501 117.5112)",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-0",
    width: 101.2,
    height: 127.4,
    x: -50.6,
    y: -63.7,
    transform: "matrix(1 0 0 1 686.334 117.5112)",
    style: {
      overflow: "visible"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFit2Fly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fit2fly.4dadcdf0.svg";
export { ForwardRef as ReactComponent };